import { render, staticRenderFns } from "./PopularCourse.vue?vue&type=template&id=534811a4"
import script from "./PopularCourse.vue?vue&type=script&lang=js"
export * from "./PopularCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports